import { render, staticRenderFns } from "./BillingManagement.vue?vue&type=template&id=ec476c0c&scoped=true&"
import script from "./BillingManagement.vue?vue&type=script&lang=ts&"
export * from "./BillingManagement.vue?vue&type=script&lang=ts&"
import style0 from "./BillingManagement.vue?vue&type=style&index=0&id=ec476c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec476c0c",
  null
  
)

export default component.exports